<template>
<!-- Shubham,5-feb-2024, Added main landmark -->
 <!-- Pooja, 11-dec-25, role only for main content not for header or footer -->
  <div id="top" :class="[isRTL ? 'rtl-global' : '']">
    <document-renderer
      v-show="$route.name!=='landing-page' || ''" 
      v-if="langCode && countryCode"
      contentType="headerMenu"
      slug="header"
      :langCode="langCode"
      :countryCode="countryCode"
      :documentId="headerDocumentId"
    ></document-renderer>
    <main >
      <router-view />
      <back-to-top />
    </main>
    <footer role="contentinfo">
      <document-renderer
        v-show="$route.name!=='landing-page' || ''" 
        v-if="langCode && countryCode"
        contentType="fullFooter"
        slug="footer"
        :langCode="langCode"
        :countryCode="countryCode"
        :documentId="footerDocumentId"
      ></document-renderer>
    </footer>
  </div>
</template>

<script>
import "@/scss/style.scss";
import { HEADER_CONTENT_ID, FOOTER_CONTENT_ID } from "@/config";
import BackToTop from "@/components/BackToTop";
import { urlCountryCode, urlLangCode } from "@/helpers/url";
import { getCountryName, getRTLCountry, getCountryResourceGroup } from "@/store/api";

export default {
  name: "App",
  components: { BackToTop },
  props: {
    isRTL: Boolean
  },
  data() {
    return {
      headerDocumentId: HEADER_CONTENT_ID,
      footerDocumentId: FOOTER_CONTENT_ID,
      countryCode: this.$route.params.countrycode,
      langCode: this.$route.params.langcode,
    };
  },
  created() {
    this.countryCode = urlCountryCode();
    this.langCode = urlLangCode();
    getCountryName(this.countryCode).then((country) => {
        this.country = country;
    });
    getRTLCountry(this.countryCode, this.langCode).then((country) => {
      if(country) {
        let itemObj = Object.keys(country).map((key) => ({ key, value: country[key] }));
        let finalItemObj = itemObj.filter(item => item.key == this.langCode);
        if(finalItemObj[0].value == 'rtl') {
          this.isRTL = true
        } else {
          this.isRTL = false
        }
      }
    });
  },
  // pooja, 04-dec-25, change lang for a page other then url's lang code
  mounted(){
    getCountryResourceGroup(this.countryCode)
      .then((res) => {
        // Pooja,12-mar-26, if substitute-langs key is present in country resource 
        // then change the lang attribute of html tag to substitute language
        if (res?.fields?.resJson?.["substitute-langs"]) {
          const subLang = res.fields.resJson?.["substitute-langs"]?.[this.langCode];
          if (subLang) {
            document.documentElement.lang = subLang;
          }
        }
    });
  },
  watch: {
    $route(newRoute, oldRoute) {
      this.countryCode = newRoute.params.countrycode;
      this.langCode = newRoute.params.langcode;
    },
  },
};
</script>

<style lang="scss">
  .rtl-global {
    direction: rtl;
  }
</style>
